import QuizIcon from '@material-ui/icons/FormatListNumbered';
import WordleGameList from './components/WordleGameList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Wordle Game',
  subMenuName: 'reports',
};

export default {
  list: WordleGameList,
  icon: QuizIcon,
  name: 'admin/reports/wordle-game',
  options,
};
